import React, { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import t from "./translations";

const I18nContext = createContext({ locale: "fr", t: t.fr, switchLocale: () => {} });

const ROUTES = {
  fr: {
    home: "/fr",
    desinfection: "/fr#desinfection",
    pourQui: "/fr#pour-qui",
    tarifs: "/fr#devis",
    contact: "/fr/contact",
    quote: "/fr/devis",
  },
  de: {
    home: "/de",
    desinfection: "/de#desinfection",
    pourQui: "/de#pour-qui",
    tarifs: "/de#devis",
    contact: "/de/kontakt",
    quote: "/de/offerte",
  },
};

const matchPage = (path) => {
  for (const lang of ["fr", "de"]) {
    if (path === ROUTES[lang].home) return "home";
    if (path === ROUTES[lang].contact) return "contact";
    if (path === ROUTES[lang].quote) return "quote";
  }
  return "home";
};

export const I18nProvider = ({ locale, children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const value = useMemo(() => {
    const dict = t[locale] || t.fr;
    const routes = ROUTES[locale];
    const switchLocale = () => {
      const other = locale === "fr" ? "de" : "fr";
      const page = matchPage(location.pathname);
      navigate(ROUTES[other][page] || ROUTES[other].home);
    };
    return { locale, t: dict, routes, switchLocale };
  }, [locale, location.pathname, navigate]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
